import { toast } from 'react-toastify';

const DEFAULT_DURATION = 5000;

export const showSuccessToast = (message: string, duration = DEFAULT_DURATION) => {
  toast.success(message, { autoClose: duration });
};

export const showErrorToast = (message: string, duration = DEFAULT_DURATION) => {
  toast.error(message, { autoClose: duration });
};

export const showInfoToast = (message: string, duration = DEFAULT_DURATION) => {
  toast.info(message, { autoClose: duration });
};

export const showWarningToast = (message: string, duration = DEFAULT_DURATION) => {
  toast.warning(message, { autoClose: duration });
};
